export const FEDEX_SHIP_TYPE = "fedex"
export const UPS_SHIP_TYPE = "ups"

const FEDEX_TRACKING_URL = "https://www.fedex.com/fedextrack/?trknbr="
const UPS_TRACKING_URL = "https://www.ups.com/track?loc=en_US&tracknum="

export const getFedexTrackingUrl = (trackingNumber: string) => `${FEDEX_TRACKING_URL}${trackingNumber}`
export const getUPSTrackingUrl = (trackingNumber: string) => `${UPS_TRACKING_URL}${trackingNumber}`
